import React, { useEffect, useState } from "react";
import styles from "./MultiRoles.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useMulti_rolesMutation } from "@src/api/LoginApiSlice";
import {
  clearIntendedPath,
  setOrgLogo,
  setParentIdByLevel,
  setTheme,
  setUserDetails,
} from "@src/app/globalSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { USER_CONSTANTS } from "@src/constants/UiConstants";
import { loadTokens } from "@src/app/authSlice";
import { toast, Typography } from "top-brains-ui";
import NavBar from "@src/components/navbar/NavBar";
import QADefaultIcon from "@src/assets/QuestionAdder.svg";
import QVDefaultIcon from "@src/assets/QuestionVerifier.svg";
import TrainerDefaultIcon from "@src/assets/Trainer.svg";
import Taskmanager from "@src/assets/TaskManager.svg";
import Admin from "@src/assets/Admin.svg";
import { RootState } from "@src/app/store";
import { mapLevel } from "@src/utils/CommonUtils";
import { setSelectedMenu } from "@src/app/headersSlice";
import { isElectronApp } from "@src/utils/envUtils";
import NavBarElectron from "@src/components/navbar/NavBarElectron";
import CommonLoader from "@src/components/loader/CommonLoader";
import { COMMON_COLORS } from "@src/styles/ColorConstants";

interface MultiRoleProps {
  handleCloseRoleSwitch?: () => void;
  defaultRole?: string;
}

const Multi_roles: React.FC<MultiRoleProps> = ({
  handleCloseRoleSwitch,
  // defaultRole,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const defaultRole = location.state?.defaultRole;
  const userRole = useSelector(
    (state: RootState) => state.globalSlice.userDetails,
  );
  const intendedPath = useSelector(
    (state: RootState) => state.globalSlice.intendedPath,
  );

  const [role, setRole] = useState(defaultRole ?? "");
  const [multi_roles, { isLoading }] = useMulti_rolesMutation();
  // const [hoverItem, setHoverItem] = useState("");

  const handleRoleChange = async (roleVal: string) => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      const refreshToken = localStorage.getItem("refreshToken");

      if (!accessToken || !refreshToken) {
        toast.error("No tokens found, please log in again.");
        return;
      }

      const response = await multi_roles({
        currentPrivilege: roleVal,
        userId: userRole?.id,
      });

      if (response?.data?.statusCode === 200) {
        sessionStorage.removeItem("hasAutoRedirected");
        dispatch({ type: "RESET_STATE" });
        dispatch(setTheme("app-theme"));
        dispatch(setOrgLogo(response?.data?.response?.logo as string));
        if (handleCloseRoleSwitch) handleCloseRoleSwitch();
        dispatch(loadTokens({ accessToken, refreshToken }));
        dispatch(setUserDetails(response?.data?.response));
        dispatch(
          setParentIdByLevel({
            level: mapLevel(response?.data?.response?.organizationType),
            id: response?.data?.response?.organizationId,
            name: response?.data?.response?.organizationName,
          }),
        );
        if (
          intendedPath?.key &&
          intendedPath.key !== "switch" &&
          (intendedPath.key === "placement" ||
            intendedPath.path.startsWith("/placement"))
        ) {
          dispatch(clearIntendedPath());
          const isStudent =
            response?.data?.response?.currentPrivilege === USER_CONSTANTS.STUDENT;
          if (isStudent) {
            navigate("/placements/home", { replace: true });
          } else {
            navigate("/placements/admin", { replace: true });
          }
          return;
        }

        if (
          intendedPath?.key &&
          intendedPath.key !== "switch" &&
          (intendedPath.key === "quiz" ||
            intendedPath.key === "tournament" ||
            intendedPath.key === "challenges" ||
            intendedPath.key === "home")
        ) {
          if (intendedPath.path === "/student-organization") {
            if (response?.data?.response?.currentPrivilege === USER_CONSTANTS.STUDENT) {
              navigate(intendedPath.path, { replace: true });
              return;
            } else {
              if (
                response?.data?.response?.currentPrivilege ===
                USER_CONSTANTS.TASK_MANAGER
              ) {
                dispatch(setTheme("app-theme"));
                navigate("/quiz", { replace: true });
              } else if (
                response?.data?.response?.currentPrivilege ===
                USER_CONSTANTS.SUPER_TASK_MANAGER
              ) {
                dispatch(setTheme("app-theme"));
                navigate("/organizations", { replace: true });
              } else if (
                response?.data?.response?.currentPrivilege ===
                USER_CONSTANTS.ADMIN
              ) {
                dispatch(setTheme("app-theme"));
                if (
                  response?.data?.response?.organizationType ===
                  "SUB_ORGANIZATION"
                ) {
                  dispatch(
                    setSelectedMenu(response?.data?.response?.organizationName),
                  );
                  navigate("/organizations/sub-organization/branch", { replace: true });
                } else if (
                  response?.data?.response?.organizationType === "BRANCH"
                ) {
                  dispatch(
                    setSelectedMenu(response?.data?.response?.organizationName),
                  );
                  navigate("/organizations/branch/branch-dashboard", { replace: true });
                } else {
                  navigate("/subjects", { replace: true });
                }
              } else {
                dispatch(setTheme("app-theme"));
                navigate("/subjects", { replace: true });
              }
            }
          } else {
            navigate(intendedPath.path, { replace: true });
            return;
          }
          dispatch(clearIntendedPath());
        } else {
          if (
            response?.data?.response?.currentPrivilege === USER_CONSTANTS.STUDENT
          ) {
            dispatch(setTheme("app-theme"));
            navigate("/student-organization", { replace: true });
          } else if (
            response?.data?.response?.currentPrivilege ===
            USER_CONSTANTS.TASK_MANAGER
          ) {
            dispatch(setTheme("app-theme"));
            navigate("/quiz", { replace: true });
          } else if (
            response?.data?.response?.currentPrivilege ===
            USER_CONSTANTS.SUPER_TASK_MANAGER
          ) {
            dispatch(setTheme("app-theme"));
            navigate("/organizations", { replace: true });
          } else if (
            response?.data?.response?.currentPrivilege === USER_CONSTANTS.ADMIN
          ) {
            dispatch(setTheme("app-theme"));
            if (
              response?.data?.response?.organizationType === "SUB_ORGANIZATION"
            ) {
              dispatch(
                setSelectedMenu(response?.data?.response?.organizationName),
              );
              navigate("/organizations/sub-organization/branch", { replace: true });
            } else if (response?.data?.response?.organizationType === "BRANCH") {
              dispatch(
                setSelectedMenu(response?.data?.response?.organizationName),
              );
              navigate("/organizations/branch/branch-dashboard", { replace: true });
            } else {
              navigate("/subjects", { replace: true });
            }
          } else {
            dispatch(setTheme("app-theme"));
            navigate("/subjects", { replace: true });
          }
        }
      } else {
        const errorMsg =
          (response as any)?.error?.data?.message ||
          (response as any)?.error?.data?.response ||
          "Failed to switch role. Please try again.";
        toast.error(errorMsg);
      }
    } catch (error: any) {
      console.log(error);
      toast.error(error?.message || "Failed to switch role");
    }
  };

  // const handleLogout = () => {
  //   dispatch(clearUserDetails());
  //   dispatch(clearHeaderState());
  //   dispatch(clearTokens());
  //   persistor.purge();
  //   navigate("/");
  // };

  useEffect(() => {
    dispatch(setTheme("website-theme"));
  }, []);

  const userIcons: Record<string, { default: string; hover: string }> = {
    SUPER_ADMIN: { default: QADefaultIcon, hover: QADefaultIcon },
    SUPER_ADDER: { default: QADefaultIcon, hover: QADefaultIcon },
    SUPER_VERIFIER: { default: QVDefaultIcon, hover: QVDefaultIcon },
    SUPER_TASK_MANAGER: { default: Taskmanager, hover: Taskmanager },
    SUPER_TRAINER: { default: TrainerDefaultIcon, hover: TrainerDefaultIcon },
    ADMIN: { default: Admin, hover: Admin },
    QUESTION_ADDER: { default: QADefaultIcon, hover: QADefaultIcon },
    QUESTION_VERIFIER: { default: QVDefaultIcon, hover: QVDefaultIcon },
    TASK_MANAGER: { default: Taskmanager, hover: Taskmanager },
    TRAINER: { default: TrainerDefaultIcon, hover: TrainerDefaultIcon },
  };

  const roleDescriptions: Record<string, string> = {
    ADMIN: "Manage system settings and user permissions.",
    QUESTION_ADDER: "Create and add new quiz questions.",
    QUESTION_VERIFIER: "Review and verify question accuracy.",
    TRAINER: "Conduct training sessions and tests.",
    TASK_MANAGER: "Organise and manage Activities & Tournaments.",
    SUPER_ADMIN: "Full control over users and platform settings.",
    SUPER_ADDER: "Create questions for quizzes, tournaments, and tests",
    SUPER_VERIFIER: "Review and verify all submitted questions.",
    SUPER_TASK_MANAGER: "Organize quizzes, tournaments, and challenges.",
    SUPER_TRAINER: "Conduct training sessions and tests.",
  };

  return (
    <>
      {isElectronApp() ? (
        <NavBarElectron links={[]} showLinks={true} />
      ) : (
        <NavBar links={[]} showLinks={true} />
      )}
      <div className={styles.mainBg}>
        <div className={styles.headingContainer}>
          <Typography className={styles.headingContent}>
            Pick your player: What’s your employee avatar for today?
          </Typography>
        </div>
        <div className={styles.contentWrapper}>
          <div className={styles.cardContainer}>
            {userRole?.privileges
              ?.filter((roleVal: string) => roleVal !== USER_CONSTANTS.STUDENT)
              .map((roleVal: string, index: number) => (
                <div
                  key={`privilege-${index}`}
                  className={`${styles.card} ${
                    role === roleVal ? styles.active : ""
                  } ${isLoading ? styles.disabled : ""}`}
                  onClick={() => {
                    if (isLoading) return;
                    setRole(roleVal);
                    handleRoleChange(roleVal);
                  }}
                >
                  <div className={styles.roleImageContainer}>
                    <img
                      src={userIcons[roleVal]?.hover}
                      alt={roleVal}
                      className={styles.userIcons}
                    />
                  </div>
                  <p>
                    {roleVal
                      .toLowerCase()
                      .replace(/_/g, " ")
                      .replace(/\b\w/g, (char) => char.toUpperCase())}
                  </p>
                  <div className={styles.roleContentContainer}>
                    <Typography
                      color="var(--website-text-color4)"
                      className={styles.roleContent}
                    >
                      {roleDescriptions[roleVal] ??
                        "Role description not available."}
                    </Typography>
                  </div>
                </div>
              ))}
          </div>

          {/* <div
            className={`${styles.buttonWrapper} ${
              role && defaultRole !== role ? styles.visible : styles.hidden
            }`}
          >
            <GradiantButton
              onClick={handleRoleChange}
              label="Continue"
              variant="primary"
              width="380px"
            />
          </div> */}
        </div>
        {isLoading && (
          <CommonLoader
            color={COMMON_COLORS.WEBSITE_GREEN_LIGHT}
            overLayColor={COMMON_COLORS.LOADER_OVERLAY}
          />
        )}
      </div>
    </>
  );
};

export default Multi_roles;
